import { Button, Flex, Spacer, Text, Wrap } from '@chakra-ui/react';

import { shadowStyles } from '@aslanpay/portal-common-lib';
import { getBulkActionsValues } from 'app/utils/table';

import { BulkActionsProps } from './types';

function BulkActions<TData extends object>({
  type,
  actions,
  selectedRows,
  totalCount,
  onSelectAll,
  isSelectingAll,
  selectedCount,
}: BulkActionsProps<TData>) {
  const bulkActionsValues = getBulkActionsValues(type, actions, selectedRows);

  const actualSelectedCount = selectedCount ?? selectedRows.length;

  const showSelectAllLink =
    totalCount !== undefined &&
    onSelectAll &&
    actualSelectedCount > 0 &&
    actualSelectedCount < totalCount;

  const showDeselectAllLink =
    totalCount !== undefined &&
    onSelectAll &&
    actualSelectedCount > 0 &&
    actualSelectedCount === totalCount;

  return (
    <Flex
      width="full"
      gap="10px"
      px="10px"
      alignItems="center"
      borderRadius="10px"
      boxShadow={shadowStyles.dropdownMenu}
      bgColor="brand.mutedPurple"
      color="brand.white"
      position="absolute"
      bottom="20px"
      left="50%"
      transform="translateX(-50%)"
      zIndex={1000}
    >
      <Text
        minW="40px"
        p="10px"
        borderRadius="5px"
        bgColor="brand.purple"
        textAlign="center"
        textStyle="h5SemiBold"
      >
        {actualSelectedCount}
      </Text>
      <Text textStyle="h6Medium">{`${bulkActionsValues?.label}s selected`}</Text>
      {showSelectAllLink && (
        <Button
          size="xs"
          variant="link"
          color="brand.white"
          onClick={onSelectAll}
          isLoading={isSelectingAll}
          textDecoration="underline"
          _hover={{ color: 'brand.mediumGray' }}
          ml="10px"
        >
          Select all ({totalCount})
        </Button>
      )}
      {showDeselectAllLink && (
        <Button
          size="xs"
          variant="link"
          color="brand.white"
          onClick={onSelectAll}
          textDecoration="underline"
          _hover={{ color: 'brand.mediumGray' }}
          ml="10px"
        >
          Deselect all ({totalCount})
        </Button>
      )}
      <Spacer />
      <Wrap>{bulkActionsValues?.bulkActions?.map((bulkAction) => bulkAction)}</Wrap>
    </Flex>
  );
}

export default BulkActions;
